import "./DocsAnalytics.css";

const DocAnalytics = () => {
  return (
    <div className="docs-analytics-container">
      <h1 className="docs-analytics-title">Workspace Analytics and Metrics</h1>

      <p className="docs-analytics-intro">
        To access detailed analytics for your chatbot, navigate to <strong>Your Bots</strong> and select the desired bot.
        Then, click the <strong>Analytics</strong> option from the left sidebar to open the analytics dashboard.
      </p>

      <p className="docs-analytics-intro">
        The analytics dashboard offers comprehensive insights into your chatbot’s performance, including:
      </p>

      <ul className="docs-analytics-list">
        <li><strong>Total Messages:</strong> The aggregate number of messages exchanged between users and the chatbot over the selected period.</li>
        <li><strong>Unique Users:</strong> The count of distinct users interacting with the chatbot, identified via email, chat sessions, or IP address.</li>
        <li><strong>Average Latency (ms):</strong> The mean response time for the chatbot, indicating how quickly it processes and returns answers.</li>
        <li><strong>Average Answer Length:</strong> The average length of chatbot responses, measured in characters.</li>
      </ul>

      <p className="docs-analytics-intro">
        Additionally, you can explore visual representations of your data, such as daily usage trends, session counts, and message volumes, to better understand user engagement and system performance.
      </p>
    </div>
  );
};

export default DocAnalytics;
